import { gql } from '@apollo/client'

// The one-time `secret` is only ever returned here.
export const API_CLIENT_CREATE = gql`
  mutation API_CLIENT_CREATE($input: ApiClientCreateInput!) {
    apiClientCreate(input: $input) {
      ok
      secret
      data {
        id
        name
        clientId
        scopes
        secretPreview
        secretExpiresAt
        active
        revokedAt
        allowedIpRanges
      }
    }
  }
`

export const API_CLIENT_UPDATE = gql`
  mutation API_CLIENT_UPDATE($id: ID!, $input: ApiClientUpdateInput!) {
    apiClientUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const API_CLIENT_REVOKE = gql`
  mutation API_CLIENT_REVOKE($id: ID!) {
    apiClientRevoke(id: $id) {
      ok
    }
  }
`
